<template>
  <div
    v-if="!$route.query.reload"
    class="the-error"
  >
    <img src="@/assets/image/pic_empty_404.png">
    <div>
      <el-button
        type="primary"
        @click="$store.dispatch('system/act_backToIndex');"
      >
        返回首页
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TheError',
    created () {
        if (this.$route.query.reload) {
            this.$router.replace({
                path: this.$store.getters['system/redirection'],
            });
        }
    },
};
</script>

<style scoped lang="scss">
  .the-error {
    text-align: center;
    padding-top: 150px;
  }
</style>
